import { Layer } from 'dashboard/components/GraphCanvasV2/layers/layer';
import CanvasTarget from 'dashboard/components/GraphCanvasV2/target/canvas-target';

export default class CanvasLayer extends Layer implements Iterable<CanvasTarget> {
  public [Symbol.iterator](): Iterator<CanvasTarget, null> {
    const els: HTMLCanvasElement[] = [];

    const {
      top: canvasTop,
      right: canvasRight,
      bottom: canvasBottom,
      left: canvasLeft,
    } = this.canvasBBox;

    if (
      canvasLeft < this.x &&
      canvasRight > this.x &&
      canvasTop < this.y &&
      canvasBottom > this.y
    ) {
      els.push(this.g6Wrapper.canvasEl);
    }
    return {
      next: function () {
        const value = els.shift();

        const result: IteratorResult<CanvasTarget, null> = value
          ? {
              value: new CanvasTarget(value),
              done: false,
            }
          : {
              value: null,
              done: true,
            };

        return result;
      }.bind(this),
    };
  }
}
